import { render, staticRenderFns } from "./SettingUploadWallpaperScreen.vue?vue&type=template&id=025923af&scoped=true&"
import script from "./SettingUploadWallpaperScreen.vue?vue&type=script&lang=js&"
export * from "./SettingUploadWallpaperScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025923af",
  null
  
)

export default component.exports